import { Product, Property } from './types';

const mergePropertyLists = (propertyLists: Property[]) =>
  propertyLists
    // combine all
    .reduce((result: Property[], props: Property) => result.concat(props), [])
    // keep unique
    .reduce(
      (result: Property[], prop: Property) =>
        result.find(item => item.id === prop.id) ? result : [...result, prop],
      []
    ) as Property[];

const getProductProps = (product: Product) =>
  product && product.properties && product.properties.nodes
    ? product.properties.nodes
    : [];

const getProductRootProps = (product: Product) =>
  getProductProps(product).filter(item => item.isRoot);

export const getProductProp = (product: Product, propId?: string | null) =>
  getProductProps(product).find(item => item.id === propId);

export const getProductListProps = (products: Product[]) => {
  return products
    ? mergePropertyLists(products.map(getProductProps) as Property[])
    : [];
};

export const getProductListRootProps = (products: Product[]) =>
  products
    ? mergePropertyLists(products.map(getProductRootProps) as Property[]).map(
        (item: Property) => ({
          id: item.id,
          name: item.name,
          children: item.children,
        })
      )
    : [];
